class MapEditType {
  static readonly edit_type_wall_1 = 1;
  static readonly edit_type_noise_2 = 2;
  static readonly edit_type_func_point_3 = 3;
  static readonly edit_type_func_area_5 = 5;
  static readonly edit_type_hand_fill_6 = 6; //手绘自动填充任务
  static readonly edit_type_hand_path_7 = 7; //手绘任务
  static readonly edit_type_add_map_func_point_100 = 100; //创建地图时的功能点编辑

  static readonly edit_default_type_0 = 0; //默认无类型
  static readonly edit_func_navigation_point_type_4 = 4; //导航点
  static readonly edit_func_stop_point_type_5 = 5; //停靠点
  static readonly edit_func_depot_point_type_6 = 6; //补给站
  static readonly edit_func_task_navigation_point_type_7 = 7; //任务详情的导航点
  static readonly edit_func_wait_lift_point_type_8 = 8; //侯梯点
  static readonly edit_func_floor_point_type_9 = 9; //电梯点
  static readonly edit_func_rfid_point_type_10 = 10; //rfid点
  static readonly edit_noise_fill_type = 2; //填充类型

  static readonly noisy_type_clean_2 = 2; //去噪点填充类型

  static readonly task_func_point_navigation_type_7 = 7; //任务详情的导航点类型

  //1-地毯区，2-减速带, 3-禁行区
  static readonly edit_func_area_type_carpet_1 = 1; //地毯区
  static readonly edit_func_area_type_speed_jhump_2 = 2; //减速带
  static readonly edit_func_area_type_no_entry_3 = 3; //禁行区
  static readonly edit_func_area_type_glassArea_4 = 4; //玻璃区
  static readonly edit_func_area_type_slopeArea_5 = 5; //斜坡区
  static readonly edit_func_area_type_liftArea_6 = 6; //电梯区
  static readonly edit_func_area_type_dynamicArea_7 = 7; //动态区
  static readonly edit_func_area_type_warningArea_8 = 8; //警示区
  static readonly edit_func_area_type_floor_lamps_9 = 9; //地灯
  static readonly edit_func_area_type_blindPathArea_10 = 10; //盲道区

  static readonly edit_func_accesscontrol_line_type_2 = 2; //门禁线

  static readonly noisy_type_clean_1 = 1; //斜坡区
}

export default MapEditType;
